import { useParams } from "react-router-dom";
import IndividualBlog from "../components/blog";
import blogdata from "../data/blog-data";

const BlogWrapper = () => {
  const { slug } = useParams();
  const blog = blogdata.find((s) => s.slug === slug);

  if (!blog) return <h2>Service Not Found</h2>;
  return (
    <>
      <IndividualBlog {...blog} />
    </>
  );
};

export default BlogWrapper;
